import { ThemeColors } from '../../../'

export interface DropzoneColors {
  Background: {
    Default: ThemeColors
    DragAccepted: ThemeColors
    Error: ThemeColors
  }
  Border: {
    Default: ThemeColors
    Active: ThemeColors
    Hover: ThemeColors
    Error: ThemeColors
    FileAccepted: ThemeColors
  }
  Icon: ThemeColors
  FontColor: {
    Default: ThemeColors
    DragAccepted: ThemeColors
    FileAccepted: ThemeColors
    Error: ThemeColors
  }
}

export const dropzoneColors: DropzoneColors = {
  Background: {
    Default: {
      default: 'bg.panel',
    },
    DragAccepted: {
      default: 'brand.subtle',
    },
    Error: {
      default: 'red.subtle',
    },
  },
  Border: {
    Default: {
      default: 'border.default',
    },
    Active: {
      default: 'brand.emphasized',
    },
    Hover: {
      default: 'border.default',
    },
    Error: {
      default: 'red.solid',
    },
    FileAccepted: {
      default: 'fg.default',
    },
  },
  Icon: {
    default: 'fg.default',
  },
  FontColor: {
    Default: {
      default: 'fg.muted',
    },
    DragAccepted: {
      default: 'brand.muted',
    },
    FileAccepted: {
      default: 'fg.default',
    },
    Error: {
      default: 'red.solid',
    },
  },
}
